{
  "tab": "Audit",
  "title": "Admin Audit Log",
  "empty": "No audit entries to display",
  "columns": {
    "at": "At",
    "actor": "Actor",
    "feature": "Feature",
    "action": "Action",
    "target": "Target",
    "scope": "Org / Location",
    "outcome": "Outcome"
  },
  "filters": {
    "actor": "Actor email",
    "actorPlaceholder": "Any actor",
    "target": "Target",
    "targetPlaceholder": "Id, email or name",
    "feature": "Feature",
    "featurePlaceholder": "All features",
    "dateRange": "Date range",
    "dateRangePlaceholder": "All dates"
  },
  "features": {
    "administration": "Administration",
    "management": "Management",
    "gmp-lamb-data-analysis": "GMP Lamb Data Analysis",
    "gmp-lamb-bookings": "GMP Lamb Bookings",
    "camera-aus-meat-omm": "MEQ Camera — AUS-MEAT OMM",
    "camera-mb-gateway-movement": "MEQ Camera — MB Gateway Movement",
    "dao-producers": "Data Analysis Overview — Producers"
  },
  "outcomes": {
    "applied": "Applied",
    "refused": "Refused"
  },
  "actor": {
    "super-admin": "Super Admin",
    "super-user": "Super User",
    "admin": "Admin",
    "user": "User",
    "unknown": "Unknown actor"
  },
  "detail": {
    "field": "Field",
    "before": "Before",
    "after": "After",
    "requestId": "Request id",
    "beforeTruncated": "Before was too large to keep ({{kilobytes}} KB)",
    "afterTruncated": "After was too large to keep ({{kilobytes}} KB)",
    "noChangedFields": "No changed fields recorded"
  },
  "recentChanges": {
    "title": "Recent changes",
    "showMore": "Show more",
    "empty": "No changes recorded for this organisation yet"
  }
}
